import * as React from "react";

const ActionItemsList = React.lazy(() => import("./ActionItemsList"));

export default {
  list: ActionItemsList,
};
